var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a6a32f13e737b37bddeb18507c1674ef09f6ad9f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@lit-fibre-ltd"]={id:"a6a32f13e737b37bddeb18507c1674ef09f6ad9f"};
      